module.exports = __webpack_public_path__ + "static/lawadvisor-services-01-eae2ff1cc57ef7ddb6948d2c5701cba4.jpg";